"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridTest = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var GridTest = function (props) {
    var styles = {
        backgroundColor: '#fff',
    };
    var ref = React.useRef();
    React.useEffect(function () {
        var _a;
        var parent = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentNode;
        while (parent) {
            var classList = typeof parent.classList ? parent.classList : '';
            if (classList) {
                if (classList.contains('container')) {
                    throw new Error("GridTest can't be nested in a \"container\" class");
                }
            }
            parent = parent.parentNode;
        }
    });
    return (React.createElement("div", { className: "debug-gridline", ref: ref },
        React.createElement("div", { className: props.fluid ? 'container-fluid' : 'container' }, props.content && props.content.map(function (row, rowIndex) {
            return (React.createElement("div", { className: "row", key: "row-" + rowIndex }, row.map(function (col, colIndex) {
                return (React.createElement("div", { className: col, key: "col-" + rowIndex + "-" + colIndex },
                    React.createElement("div", { className: "gutter-px gutter-mb", style: styles },
                        React.createElement("p", { style: { background: 'rgba(0, 0, 0, 0.1)' } }, col))));
            })));
        }))));
};
exports.GridTest = GridTest;
exports.GridTest.defaultProps = {
    content: [
        ['col-12'],
        ['col-12 col-sm-6', 'col-12 col-sm-6'],
        ['col-12 col-sm-6 col-lg-3', 'col-12 col-sm-6 col-lg-3', 'col-12 col-sm-6 col-lg-3', 'col-12 col-sm-6 col-lg-3'],
        ['col-12'],
    ],
    fluid: false,
};
exports.GridTest.propTypes = {
    content: PropTypes.arrayOf(PropTypes.array),
    fluid: PropTypes.bool,
};
